/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-07-05 09:21:29
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-09-15 14:12:46
 * @FilePath: /vue_huaqiang/src/router/modules/report-management.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {RouteConfig} from "vue-router";
import Layout from "@/layout/index.vue";

const reportManagementRoutes: RouteConfig[] = [
    {
        path: "/report-management",
        component: Layout,
        redirect: "/report-management/space",
        name: "ReportManagement",
        meta: {
            title: "reportManagement",
            icon: "el-icon-notebook-2",
            alwaysShow: true
        },
        children: [
            {
                path: "/report",
                component: () => import("@/views/report-management/ReportManagement.vue"),
                name: "reportDetails",
                meta: { title: "reportDetails" }
            },
            {
                path: "/dataConnection",
                component: () => import("@/views/report-management/dataConnection.vue"),
                name: "dataConnection",
                meta: { title: "dataConnection" }
            },
        ],
    }
];

export default reportManagementRoutes;
